import { getCouponTitle, getTrackingId } from '../../Utils'

let fireworks

const showEffect = (isConfetti) => {
  let resultPage = document.getElementById('kariba_result_container_result_random_gift')
  if (resultPage) {
    if (isConfetti) {
      const canvas = document.getElementById('kariba_effect_canvas')
      const myConfetti = confetti.create(canvas, { resize: true, useWorker: true })
      myConfetti({ particleCount: 100, spread: 160 })
    } else {
      const wrapper = document.getElementById('effect_wrapper')
      fireworks = new Fireworks(wrapper)
      fireworks.start()
    }
  }
}

export const generateResultPage = (data, coupon) => {
  const bgUrl = data?.background.url || ''
  const bgColor = data?.background.color
  const giftImage = data.imgGift?.url || ''
  const title = data?.text?.content || ''
  const titleStyle = data?.text?.style || {}
  const text_1 = data?.text_1?.content || ''
  const text_1Style = data?.text_1?.style || {}
  const text_2 = data?.text_2?.content || ''
  const text_2Style = data?.text_2?.style || {}
  const buttonText = data?.button?.content || ''
  const buttonStyle = data?.button?.style || {}
  const isConfetti = data?.background?.effects == 'Confetti'

  const html = `
    <div id="kariba_result_container_result_random_gift" class="kariba-random-gift-result-container">
      <div class="k-result-wrapper" style="background: url(${bgUrl}); background-color: ${bgColor};">
        <div id="kariba_close_random_gift" class="kariba-mingame-close-btn">
          <i class="material-icons">&#xe5cd;</i>
        </div>
        <img style="margin-top: 16px" id="kariba_spin_gift_image" src=${giftImage} alt="gift image" class="kariba-image-decorator"/>
        <span style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
          color: ${titleStyle.color || '#FA541C'};
          font-size: ${titleStyle.fontSize || 36}px;
          font-weight: ${titleStyle.fontStyle || 'bold'};
          text-align: ${titleStyle.textAlign || 'center'};
          margin-bottom: 16px;
          margin-top: 10px;
          ">${title}</span>
          <span style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
          color: ${titleStyle.color || '#FA541C'};
          font-size: ${titleStyle.fontSize || 36}px;
          font-weight: ${titleStyle.fontStyle || 'bold'};
          text-align: ${titleStyle.textAlign || 'center'};
          margin-bottom: 16px;
          ">${coupon?.title}</span>

        <span style="font-family: ${text_1Style.fontFamily || 'Inter'}; 
          color: ${text_1Style.color || '#000000'};
          font-size: ${text_1Style.fontSize || 20}px;
          font-weight: ${text_1Style.fontStyle || 'bold'};
          text-align: ${text_1Style.textAlign || 'center'};
          margin-bottom: 15px;
          line-height: 24px;
          ">${text_1}</span>

        <span style="font-family: ${text_2Style.fontFamily || 'Inter'}; 
          color: ${text_2Style.color || '#FA541C'};
          font-size: ${text_2Style.fontSize || 20}px;
          font-weight: ${text_2Style.fontStyle || 'bold'};
          text-align: ${text_2Style.textAlign || 'center'};
          margin-bottom: 15px;
          ">${text_2}</span>

        <button
          id="kariba_continue_shopping"
          style="font-family: ${buttonStyle.fontFamily || 'Inter'}; 
          background-color: ${buttonStyle.backgroundColor || '#FA541C'};
          color: ${buttonStyle.color || '#FFF'};
          font-size: ${buttonStyle.fontSize || 12}px;
          font-weight: ${buttonStyle.fontStyle || 'nomal'};
          text-align: ${buttonStyle.textAlign || 'center'};"
          >${buttonText}
        </button>
        <canvas id="kariba_effect_canvas"></canvas>
        <div id="effect_wrapper"></div>
      </div>
    </div>`

  document.body.innerHTML += html

  fireworks = showEffect(isConfetti)
  let continueShoppingBtn = document.getElementById('kariba_continue_shopping')
  continueShoppingBtn.addEventListener('click', () => {
    document.getElementById('kariba_result_container_result_random_gift')?.remove()
    if (!isConfetti && fireworks) fireworks.stop()
  })
}
